import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import References from './pages/References';
import ProjectDetail from './pages/ProjectDetail';
import Contact from './pages/Contact';
import About from './pages/About';

function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/om-os" element={<About />} />
        <Route path="/ydelser" element={<Services />} />
        <Route path="/referencer" element={<References />} />
        <Route path="/referencer/:slug" element={<ProjectDetail />} />
        <Route path="/kontakt" element={<Contact />} />
      </Routes>
    </Layout>
  );
}

export default App;
